










































import { Component, Vue } from 'vue-property-decorator';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import '@fortawesome/fontawesome-free'
import Grid from '@/components/Grid.vue';
import { Tile, TileValueTypes } from '@/components/Tile.vue';

@Component({
  components: {
    Grid,
    Tile,
  },
})

export default class App extends Vue {
  private isGameOver: boolean = false;
  private winner: TileValueTypes = TileValueTypes.None;
  private currentPlayer: TileValueTypes = TileValueTypes.None;

  private onPlayerChanged(player: TileValueTypes): void {
    this.currentPlayer = player;
  }

  private onRestartButtonClicked(): void {
    this.isGameOver = false;
    this.winner = TileValueTypes.None;
    this.$emit('restart');
  }

  private onGameOver(winner: TileValueTypes): void {
    this.isGameOver = true;
    this.winner = winner;
  }
}
App.use(Buefy);
